
import React, { useState, useEffect, useContext, useCallback } from "react";
import {
    Panel,
    PanelHeader,
    PanelBody,
    PanelFooter,
} from "./../../components/panel/panel.jsx";
import {
    CheckStorageLimit,
    GetUsrLoginPackageDetail,
} from "../../api/packageApi";
import Config from "../../Config.js";
import swal from "sweetalert";
import { Link, useHistory } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import LoaderSpinner from "../../components/Loaderspinner/LoaderSpinner";

const Branding = () => {
    let history = useHistory();
    const [BrandingLogoPath, setBrandingLogoPath] = useState("");
    const [BrandingLogoPathID, setBrandingLogoPathID] = useState("");
    const [BrandingLogoPathOld, setBrandingLogoPathOld] = useState("");
    const [BrandingFile, setBrandingFile] = useState(null);
    const [WhiteLabellingName, setWhiteLabellingName] = useState("");
    const [WhiteLabellingNameOld, setWhiteLabellingNameOld] = useState("");
    const [WhiteLabellingNameError, setWhiteLabellingNameError] = useState("");
    const [isWhiteLabellingEdit, setIsWhiteLabellingEdit] = useState(false);
    const [rolename, setroleName] = useState(
        localStorage.getItem("loginRoleName")
    );

    const [BrandingLogoID, setBrandingLogoID] = useState("");
    const [CompanyID, setCompanyID] = useState("");
    const [isLoding, setisLoding] = useState(false);
    const [isLodingBardinglogo, setLodingBardinglogo] = useState(false);
    const [isFileuploadLoding, setisFileuploadLoding] = useState(false);
    const [isDeleteLoding, setisDeleteLoding] = useState(false);
    const [iswhiteLabeling, setiswhiteLabeling] = useState(false);
    const [isbardingshow, setisbardingshow] = useState(false);

    const [IsPublishedBarding, setIsPublishedBarding] = useState(false);
    const [IsPublishedTagLine, setIsPublishedTagLine] = useState(false);
    const [EditIsPublishedBarding, setEditIsPublishedBarding] = useState(false);
    const [EditIsPublishedTagLine, setEditIsPublishedTagLine] = useState(false);

    useEffect(() => {
        let checkLogin = localStorage.getItem("loginUserID");
        if (
            checkLogin === "" ||
            checkLogin === "" ||
            checkLogin === undefined ||
            checkLogin === null
        ) {
            return () => {
                history.push("/Login");
            };
        } else {
            setCompanyID(checkLogin);
            BindIndivualId(checkLogin);
            getUsrLoginPackageDetail();
        }
        //setCurrentUserLoginName(localStorage.getItem("loginName"));
    }, []);


    const getUserBrandingLogo = async (Parentid) => {
        let loginid = localStorage.getItem("loginUserID");
        let Auth0token = localStorage.getItem("Auth0token");
        let TargetID = "";
        if (Parentid !== null && Parentid !== "" && Parentid !== undefined) {
            TargetID = Parentid;
        } else {
            TargetID = loginid;
        }
        setLodingBardinglogo(true);

        fetch(
            Config.apiUrl +
            "FileUpload/?targetID=" +
            TargetID +
            "&FileType=" +
            "bardinglogoimage",
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    userCompanyID: loginid,
                    Authorization: "Bearer " + Auth0token,
                },
            }
        ).then((resp1) => {
            resp1.json().then((result) => {
                if (result != null && result.length > 0) {
                    setBrandingLogoPathID(result[0]._id);
                    setBrandingLogoPath(Config.contentUrl + result[0].filePath);
                    setBrandingLogoPathOld(Config.contentUrl + result[0].filePath)
                } else {
                    setBrandingLogoPath("");
                    setBrandingLogoPathID("");
                    setBrandingLogoPathOld("")
                }
                setLodingBardinglogo(false);
            });
        });
    };
    const onChangeWhiteLabelling = (event) => {
        if (rolename == "Admin") {
            setWhiteLabellingName(event.target.value);
            setWhiteLabellingNameError("");
        }
    };
    const SelsectBrandingFile = (event) => {
        if (rolename == "Admin") {
            setBrandingLogoPath(URL.createObjectURL(event.target.files[0]));
            setBrandingFile(event.target.files[0]);
        }
    };

    const CreateBardinglogo = async () => {
        let loginid = localStorage.getItem("loginUserID");
        let Auth0token = localStorage.getItem("Auth0token");
        const byte = BrandingFile.size;
        let StorageResponse = await CheckStorageLimit(byte);
        if (StorageResponse === false || StorageResponse === "false") {
            swal(
                "Saved",
                "Sorry! Your profile details are updated and to update your image increase your storage limit.",
                "success"
            );
        } else {
            setisFileuploadLoding(true);
            const formData = new FormData();
            formData.append("body", BrandingFile);
            formData.append("fileType", "bardinglogoimage");
            formData.append("targetId", loginid);
            formData.append("externalLink", "");
            formData.append("displayOrder", "0");
            fetch(Config.apiUrl + "FileUpload/Update?id=" + "", {
                headers: {
                    userCompanyID: loginid,
                    Authorization: "Bearer " + Auth0token,
                },
                method: "PUT",
                body: formData,
            })
                .then((res) => res.json())
                .then(async (json) => {
                    setisFileuploadLoding(false)
                    BindIndivualId(CompanyID);
                })
        }
    };

    const submitBardingandwhiteLabeling = () => {
        setiswhiteLabeling(true);
        try {
            let checkLogin = localStorage.getItem("loginUserID");
            let Auth0token = localStorage.getItem("Auth0token");
            fetch(
                Config.apiUrl +
                "UserCompany/UpdateWhiteLabelling?id=" + checkLogin + "&WhiteLabellingName=" + WhiteLabellingName +"&IsPublishedBarding="+EditIsPublishedBarding+ "&IsPublishedTagLine="+EditIsPublishedTagLine, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    userCompanyID: checkLogin,
                    Authorization: "Bearer " + Auth0token,
                },
            })
                .then((res) => res.json())
                .then(async (json) => {
                    if (json === true) {
                        if (BrandingFile !== null && BrandingFile !== "" && BrandingFile !== undefined) {
                            CreateBardinglogo();
                        }
                        else {
                            BindIndivualId(CompanyID);
                        }
                        setiswhiteLabeling(false);
                    }
                })
        } catch (error) {
            setiswhiteLabeling(false);
            console.log("Error=====>", error)
        }
    }


    const BindIndivualId = async (loginUserID) => {
        try {
            let Auth0token = localStorage.getItem("Auth0token");
            if (loginUserID != null && loginUserID != "" && loginUserID != undefined) {
                setisLoding(true);
                fetch(Config.apiUrl + "UserCompany/ById?id=" + loginUserID, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + Auth0token,
                    },
                }).then((resp1) => {
                    resp1.json().then(async (result) => {
                        if (result != null && result?._id !== null && result?._id !== "") {
                            setWhiteLabellingNameOld(result?.whiteLabellingName ? result?.whiteLabellingName : "");
                            setWhiteLabellingName(result?.whiteLabellingName ? result?.whiteLabellingName : "")
                            setIsPublishedBarding(result?.isPublishedBarding ? result?.isPublishedBarding : false);
                            setIsPublishedTagLine(result?.isPublishedTagLine ? result?.isPublishedTagLine : false);
                            setEditIsPublishedBarding(result?.isPublishedBarding ? result?.isPublishedBarding : false);
                            setEditIsPublishedTagLine(result?.isPublishedTagLine ? result?.isPublishedTagLine : false)
                            if (result?.roleDetail?.roleName === "SubUser") {
                                await getUserBrandingLogo(result?.parentID);
                            } else {
                                await getUserBrandingLogo("");
                            }
                            editWhiteLabellingEdit();
                            setisLoding(false);
                        } else {
                            swal("User not Found");
                        }
                    });
                });
            }
        } catch (error) {
            console.log("error=====>", error)
            setisLoding(false);
        }

    };

    const editWhiteLabellingEdit = () => {
        setIsWhiteLabellingEdit(false)
        setBrandingFile(null);
        setWhiteLabellingName(WhiteLabellingNameOld);
        setBrandingLogoPath(BrandingLogoPathOld)
    };

    const DeleteLableDetails = (L_ID) => {
        try {
            if (L_ID != "" && L_ID != "" && L_ID != undefined) {
                let loginid = localStorage.getItem("loginUserID");
                let Auth0token = localStorage.getItem("Auth0token");
                swal({
                    title: "Are you sure?",
                    text: "Once deleted, you will not be able to recover this Label !",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                }).then((willDelete) => {
                    if (willDelete) {
                        fetch(Config.apiUrl + "Label/Delete?id=" + L_ID, {
                            method: "DELETE",
                            headers: {
                                "Content-Type": "application/json",
                                userCompanyID: loginid,
                                Authorization: "Bearer " + Auth0token,
                            },
                        }).then((result) => {
                            result.json().then((resp) => {
                                if (resp === true) {
                                    setBrandingLogoPath("");
                                    setBrandingLogoPathOld("");
                                    swal("Congratulations! Your data deleted successfully.", {
                                        icon: "success",
                                    });
                                } else {
                                    swal("Your Barding logo is safe!");
                                }
                            });
                        });
                    }
                });
            }
        } catch (error) {
            console.log("error=====>", error);
        }

    };

    const getUsrLoginPackageDetail = async () => {
        try {
            let response = await GetUsrLoginPackageDetail();
            if (response?.userPackageFeatureDetail?.isYourBranding) {
                setisbardingshow(response?.userPackageFeatureDetail?.isYourBranding ? response?.userPackageFeatureDetail?.isYourBranding : false);
            }
            else {
                setisbardingshow(false)
            }
        } catch (error) {
            console.log("Error===>", error)
            setisbardingshow(false)
        }
    };

    const UpdateIsPublishedBarding = (PublishedBarding) => {
        let loginid = localStorage.getItem("loginUserID");
        let Auth0token = localStorage.getItem("Auth0token");
        fetch(
            Config.apiUrl +
            "UserCompany/UpdateIsPublishedBarding?id=" +
            loginid +
            "&ISPublished=" +
            PublishedBarding,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    userCompanyID: loginid,
                    subUserCompanyID: [],
                    Authorization: "Bearer " + Auth0token,
                },
            }
        )
            .then((response) => {
                if (response?.status === 401) {
                    history.push('/Logout');
                }
                if (response.ok) {
                    return response.json();
                }
                throw new Error("Something went wrong");
            })
            .then(async (responseJson) => {
                if (responseJson === true) {
                    await BindIndivualId(CompanyID)
                    // setIsPublishedBarding(PublishedBarding);
                    swal("Congratulations ! update successfully.", {
                        icon: "success",
                    });
                }
                else {
                    swal("Sorry!", "Not update.", "error");
                }

            })
            .catch((error) => {
                swal("Sorry!", "Not update.", "error");
            });
    }

    const UpdateIsPublishedTagLine = (PublishedTagLine) => {
        let loginid = localStorage.getItem("loginUserID");
        let Auth0token = localStorage.getItem("Auth0token");
        fetch(
            Config.apiUrl +
            "UserCompany/UpdateIsPublishedTagLine?id=" +
            loginid +
            "&ISPublished=" +
            PublishedTagLine,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    userCompanyID: loginid,
                    subUserCompanyID: [],
                    Authorization: "Bearer " + Auth0token,
                },
            }
        )
            .then((response) => {
                if (response?.status === 401) {
                    history.push('/Logout');
                }
                if (response.ok) {
                    return response.json();
                }
                throw new Error("Something went wrong");
            })
            .then(async (responseJson) => {
                if (responseJson === true) {
                    await BindIndivualId(CompanyID);
                    // setIsPublishedTagLine(PublishedTagLine)
                    swal("Congratulations ! update successfully.", {
                        icon: "success",
                    });
                }
                else {
                    swal("Sorry!", "Not update.", "error");
                }

            })
            .catch((error) => {
                swal("Sorry!", "Not update.", "error");
            });
    }
    return (
        <div>
            {
                rolename === "Admin" ?
                    <div id="main-wrapper">
                        <LoaderSpinner isrefresh={isLoding || isLodingBardinglogo || isFileuploadLoding || isDeleteLoding || iswhiteLabeling} />
                        {
                            isbardingshow ?
                                <Panel>
                                    <PanelHeader>
                                        <h4 className="mb-0 text-light">Branding</h4>
                                    </PanelHeader>
                                    <PanelBody className="p-0 bgwhite">
                                        <div className="form-group row mb-0 profile-box p-0 mx-0 ">
                                            <label className="col-xl-2 col-form-label left-border">
                                                <h5 className="mb-0">Branding Logo </h5>
                                            </label>
                                            <div className="custom-file file-upload-height align-items-center py-3">
                                                <img
                                                    src={BrandingLogoPathOld}
                                                    className="img-upload-size"
                                                    style={{ height: "60px" }}
                                                    onError={({ currentTarget }) => {
                                                        currentTarget.onerror = null; // prevents looping
                                                        currentTarget.src =
                                                            "../assets/img/new-images/images.png";
                                                    }}
                                                ></img>
                                            </div>
                                            <div className="col-xl-4 d-flex align-items-center py-3">
                                                <div className="checkbox checkbox-css checkbox-inline pt-0">
                                                    <input
                                                        type="checkbox"
                                                        checked={IsPublishedBarding}
                                                        onChange={async (e) => {
                                                            await UpdateIsPublishedBarding(!IsPublishedBarding);
                                                        }}
                                                        id="inlineCssCheckboxc2Barding"
                                                    />
                                                    <label htmlFor="inlineCssCheckboxc2Barding">Publish</label>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="form-group mb-0 row profile-box p-0 mx-0 ">
                                            <label className="col-xl-2 col-form-label left-border">
                                                <h5 className="mb-0">Tag Line : </h5>
                                            </label>
                                            <div className="col-xl-6 d-flex align-items-center py-3">
                                                <h5 className="mb-0">{WhiteLabellingNameOld ? WhiteLabellingNameOld : "N/A"}</h5>
                                            </div>
                                            <div className="col-xl-4 d-flex align-items-center py-3">
                                                <div className="checkbox checkbox-css checkbox-inline pt-0">
                                                    <input
                                                        type="checkbox"
                                                        checked={IsPublishedTagLine}
                                                        onChange={async (e) => {
                                                            await UpdateIsPublishedTagLine(!IsPublishedTagLine);
                                                        }}
                                                        id="inlineCssCheckboxc2"
                                                    />
                                                    <label htmlFor="inlineCssCheckboxc2">Publish</label>
                                                </div>
                                            </div>

                                        </div>
                                        {
                                            rolename === "Admin" && isWhiteLabellingEdit === false ?
                                                <button
                                                    type="button"
                                                    onClick={() => { setIsWhiteLabellingEdit(true); setWhiteLabellingName(WhiteLabellingNameOld); setBrandingLogoPath(BrandingLogoPathOld) }}
                                                    className="btn btn-primary shadow-add my-3 m-l-10 m-r-10"
                                                >
                                                    Edit Branding
                                                </button>
                                                : <></>

                                        }
                                        <Modal isOpen={isWhiteLabellingEdit} toggle={editWhiteLabellingEdit} onHide={() => isWhiteLabellingEdit(false)}>
                                            <ModalHeader toggle={editWhiteLabellingEdit} className="modalheader">
                                                <h4 className="text-white mb-0">Edit Branding</h4>
                                            </ModalHeader>
                                            <ModalBody>
                                                <>
                                                    <div className="form-group row">
                                                        <label className="col-xl-3">
                                                            <h5 className="mb-0">Branding Logo</h5>
                                                        </label>
                                                        <div className="col-xl-2 d-flex align-items-center">
                                                            <div className="custom-file file-upload-height">
                                                                <input
                                                                    disabled={rolename == "Admin" ? false : true}
                                                                    type="file"
                                                                    onChange={(e) => SelsectBrandingFile(e)}
                                                                    className="custom-file-input file-upload-height"
                                                                    accept="image/x-png, image/gif, image/jpeg"
                                                                    max-size="2000"
                                                                />
                                                                <label
                                                                    className=" profile-upload-1 file-upload-height"
                                                                    for="customFile "
                                                                >
                                                                    {BrandingLogoPath ? (
                                                                        <img
                                                                            src={BrandingLogoPath}
                                                                            className="img-upload-size"
                                                                            style={{ height: "60px" }}
                                                                            onError={({ currentTarget }) => {
                                                                                currentTarget.onerror = null; // prevents looping
                                                                                currentTarget.src =
                                                                                    "../assets/img/new-images/images.png";
                                                                            }}
                                                                        ></img>
                                                                    ) : (
                                                                        <p className="mb-0">Add Branding Logo</p>
                                                                    )}

                                                                    <div className="file-upload-3 ">
                                                                        <i className="ion ion-md-camera  fa-sm"></i>
                                                                    </div>
                                                                </label>
                                                            </div>
                                                            <div className="checkbox checkbox-css checkbox-inline pt-0">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={EditIsPublishedBarding}
                                                                    onChange={(e) => {
                                                                       setEditIsPublishedBarding(!EditIsPublishedBarding)
                                                                    }}
                                                                    id="inlineCssCheckboxc2BardingEdit"
                                                                />
                                                                <label htmlFor="inlineCssCheckboxc2BardingEdit">Publish</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-xl-3">
                                                            <h5 className="mb-0">Tag Line</h5>
                                                        </label>
                                                        <div className="col-xl-6">
                                                            <input
                                                                disabled={rolename == "Admin" ? false : true}
                                                                type="text"
                                                                maxLength="20"
                                                                className="form-control input-design-1"
                                                                placeholder="Enter White Labelling"
                                                                value={WhiteLabellingName}
                                                                onChange={onChangeWhiteLabelling}
                                                            />
                                                            <p
                                                                style={{
                                                                    textAlign: "right",
                                                                    fontSize: 12,
                                                                    color: "red",
                                                                }}
                                                            >
                                                                {WhiteLabellingName.length}/20
                                                            </p>
                                                        </div>
                                                        <div className="checkbox checkbox-css checkbox-inline pt-0">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={EditIsPublishedTagLine}
                                                                    onChange={(e) => {
                                                                       setEditIsPublishedTagLine(!EditIsPublishedTagLine)
                                                                    }}
                                                                    id="inlineCssCheckboxc2Edit"
                                                                />
                                                                <label htmlFor="inlineCssCheckboxc2Edit">Publish</label>
                                                            </div>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        onClick={() => submitBardingandwhiteLabeling()}
                                                        className="btn btn-primary shadow-add my-3 m-l-10 m-r-10"
                                                    >
                                                        Save Changes
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger shadow-add my-3 "
                                                        onClick={(e) => { setBrandingFile(null); setWhiteLabellingName(WhiteLabellingNameOld); setIsWhiteLabellingEdit(false); setBrandingLogoPath(BrandingLogoPathOld) }}

                                                    >
                                                        Discard
                                                    </button>
                                                </>

                                            </ModalBody>
                                        </Modal>


                                    </PanelBody>
                                </Panel>
                                : <> <div className="access-denied-container"><p>Update your barding package</p></div></>
                        }
                    </div>
                    : <>  <div className="access-denied-container"><img src="../assets/img/logo/abc.png"></img></div></>}
        </div>
    )
}
export default Branding;